<template>
  <quiz-field-wrapper
    :title="fieldTitle"
    :description="fieldDescription"
    size="ld"
  >
    <template #default>
      <div v-if="innerWidth < 1000">
        <swiper
          :space-between="16"
          :slidesPerView="'auto'"
          :pagination="{
            clickable: true,
          }"
          @swiper="onSwiper"
          @slideChange="onSlideChange"
          :enabled="false"
          :resizeObserver="true"
        >
          <swiper-slide
            v-for="(comment, i) in question.testimonials"
            :key="comment.author_name + i"
          >
            <div class="quiz-comment-card">
              <p class="quiz-comment-card__text">
                {{ comment.text }}
              </p>
              <div class="quiz-comment-card__bottom">
                <img :src="comment.author_picture" />
                <div class="quiz-comment-card__info">
                  <p class="quiz-comment-card__name">
                    {{ comment.author_name }}
                  </p>
                  <svg width="112" height="16" viewBox="0 0 112 16" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><g clip-path="url(#clip0_1283_11983)"><path d="M16 5.56a.327.327 0 00-.313-.227h-5.434L8.333.22a.333.333 0 00-.626 0l-1.92 5.113H.353a.327.327 0 00-.313.227.32.32 0 00.107.366l4.48 3.86-1.92 5.774a.333.333 0 00.506.373l4.807-3.52 4.807 3.52a.332.332 0 00.505-.17.333.333 0 00.001-.203l-1.92-5.774 4.48-3.86A.32.32 0 0016 5.56z" fill="#fff"/></g><g clip-path="url(#clip1_1283_11983)"><path d="M40 5.56a.327.327 0 00-.313-.227h-5.434L32.333.22a.333.333 0 00-.626 0l-1.92 5.113h-5.433a.327.327 0 00-.314.227.32.32 0 00.107.366l4.48 3.86-1.92 5.774a.333.333 0 00.506.373l4.807-3.52 4.807 3.52a.332.332 0 00.505-.17.333.333 0 00.001-.203l-1.92-5.774 4.48-3.86A.32.32 0 0040 5.56z" fill="#fff"/></g><g clip-path="url(#clip2_1283_11983)"><path d="M64 5.56a.327.327 0 00-.313-.227h-5.434L56.333.22a.333.333 0 00-.626 0l-1.92 5.113h-5.434a.327.327 0 00-.313.227.32.32 0 00.107.366l4.48 3.86-1.92 5.774a.333.333 0 00.506.373l4.807-3.52 4.807 3.52a.332.332 0 00.505-.17.333.333 0 00.001-.203l-1.92-5.774 4.48-3.86A.32.32 0 0064 5.56z" fill="#fff"/></g><g clip-path="url(#clip3_1283_11983)"><path d="M88 5.56a.327.327 0 00-.313-.227h-5.434L80.333.22a.333.333 0 00-.626 0l-1.92 5.113h-5.434a.327.327 0 00-.313.227.32.32 0 00.107.366l4.48 3.86-1.92 5.774a.333.333 0 00.506.373l4.807-3.52 4.807 3.52a.332.332 0 00.505-.17.333.333 0 00.001-.203l-1.92-5.774 4.48-3.86A.32.32 0 0088 5.56z" fill="#fff"/></g><g clip-path="url(#clip4_1283_11983)"><path d="M112 5.56a.326.326 0 00-.313-.227h-5.434L104.333.22a.331.331 0 00-.626 0l-1.92 5.113h-5.434a.327.327 0 00-.313.227.32.32 0 00.107.366l4.48 3.86-1.92 5.774a.333.333 0 00.506.373l4.807-3.52 4.807 3.52a.332.332 0 00.506-.373l-1.92-5.774 4.48-3.86A.318.318 0 00112 5.56z" fill="#fff"/></g><defs><clipPath id="clip0_1283_11983"><path fill="#fff" d="M0 0h16v16H0z"/></clipPath><clipPath id="clip1_1283_11983"><path fill="#fff" transform="translate(24)" d="M0 0h16v16H0z"/></clipPath><clipPath id="clip2_1283_11983"><path fill="#fff" transform="translate(48)" d="M0 0h16v16H0z"/></clipPath><clipPath id="clip3_1283_11983"><path fill="#fff" transform="translate(72)" d="M0 0h16v16H0z"/></clipPath><clipPath id="clip4_1283_11983"><path fill="#fff" transform="translate(96)" d="M0 0h16v16H0z"/></clipPath></defs></svg>
                </div>
              </div>
            </div>
          </swiper-slide>
        </swiper>
      </div>
      <div style="display: flex; gap: 16px" v-else>
        <div
          v-for="(comment, i) in question.testimonials"
          :key="comment.author_name + i"
        >
          <div class="quiz-comment-card">
            <p class="quiz-comment-card__text">
              {{ comment.text }}
            </p>
            <div class="quiz-comment-card__bottom">
              <img :src="comment.author_picture" />
              <div class="quiz-comment-card__info">
                <p class="quiz-comment-card__name">
                  {{ comment.author_name }}
                </p>
                <svg width="112" height="16" viewBox="0 0 112 16" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><g clip-path="url(#clip0_1283_11983)"><path d="M16 5.56a.327.327 0 00-.313-.227h-5.434L8.333.22a.333.333 0 00-.626 0l-1.92 5.113H.353a.327.327 0 00-.313.227.32.32 0 00.107.366l4.48 3.86-1.92 5.774a.333.333 0 00.506.373l4.807-3.52 4.807 3.52a.332.332 0 00.505-.17.333.333 0 00.001-.203l-1.92-5.774 4.48-3.86A.32.32 0 0016 5.56z" fill="#fff"/></g><g clip-path="url(#clip1_1283_11983)"><path d="M40 5.56a.327.327 0 00-.313-.227h-5.434L32.333.22a.333.333 0 00-.626 0l-1.92 5.113h-5.433a.327.327 0 00-.314.227.32.32 0 00.107.366l4.48 3.86-1.92 5.774a.333.333 0 00.506.373l4.807-3.52 4.807 3.52a.332.332 0 00.505-.17.333.333 0 00.001-.203l-1.92-5.774 4.48-3.86A.32.32 0 0040 5.56z" fill="#fff"/></g><g clip-path="url(#clip2_1283_11983)"><path d="M64 5.56a.327.327 0 00-.313-.227h-5.434L56.333.22a.333.333 0 00-.626 0l-1.92 5.113h-5.434a.327.327 0 00-.313.227.32.32 0 00.107.366l4.48 3.86-1.92 5.774a.333.333 0 00.506.373l4.807-3.52 4.807 3.52a.332.332 0 00.505-.17.333.333 0 00.001-.203l-1.92-5.774 4.48-3.86A.32.32 0 0064 5.56z" fill="#fff"/></g><g clip-path="url(#clip3_1283_11983)"><path d="M88 5.56a.327.327 0 00-.313-.227h-5.434L80.333.22a.333.333 0 00-.626 0l-1.92 5.113h-5.434a.327.327 0 00-.313.227.32.32 0 00.107.366l4.48 3.86-1.92 5.774a.333.333 0 00.506.373l4.807-3.52 4.807 3.52a.332.332 0 00.505-.17.333.333 0 00.001-.203l-1.92-5.774 4.48-3.86A.32.32 0 0088 5.56z" fill="#fff"/></g><g clip-path="url(#clip4_1283_11983)"><path d="M112 5.56a.326.326 0 00-.313-.227h-5.434L104.333.22a.331.331 0 00-.626 0l-1.92 5.113h-5.434a.327.327 0 00-.313.227.32.32 0 00.107.366l4.48 3.86-1.92 5.774a.333.333 0 00.506.373l4.807-3.52 4.807 3.52a.332.332 0 00.506-.373l-1.92-5.774 4.48-3.86A.318.318 0 00112 5.56z" fill="#fff"/></g><defs><clipPath id="clip0_1283_11983"><path fill="#fff" d="M0 0h16v16H0z"/></clipPath><clipPath id="clip1_1283_11983"><path fill="#fff" transform="translate(24)" d="M0 0h16v16H0z"/></clipPath><clipPath id="clip2_1283_11983"><path fill="#fff" transform="translate(48)" d="M0 0h16v16H0z"/></clipPath><clipPath id="clip3_1283_11983"><path fill="#fff" transform="translate(72)" d="M0 0h16v16H0z"/></clipPath><clipPath id="clip4_1283_11983"><path fill="#fff" transform="translate(96)" d="M0 0h16v16H0z"/></clipPath></defs></svg>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
    <template #actions>
      <div class="quiz-btn__container">
        <button
          class="quiz__btn btn-reset quiz-btn quiz-btn--md quiz-btn--white"
          @click="$emit('next')"
        >
          Continue
        </button>
      </div>
    </template>
  </quiz-field-wrapper>
</template>

<script>
import QuizFieldWrapper from './QuizFieldWrapper.vue'
import { Swiper, SwiperSlide } from 'swiper/vue'
import SwiperCore, { Pagination } from 'swiper'
SwiperCore.use([Pagination])

export default {
  name: 'QuizTestimonialsField',
  components: { Swiper, SwiperSlide, QuizFieldWrapper },
  props: ['fieldTitle', 'fieldDescription', 'question'],
  emits: ['next'],
  data: () => ({
    innerWidth: 0,
  }),
  methods: {
    onSwiper() {},
    onSlideChange() {},
    listenResize() {
      this.innerWidth = window.innerWidth
    },
  },
  mounted() {
    this.listenResize()

    window.addEventListener('resize', this.listenResize)
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.listenResize)
  },
}
</script>

<style scoped lang="scss"></style>
